<script>
import { mount_component } from "svelte/internal";

	import { onMount } from 'svelte';
    export let headline ="";
    export let subheadline ="";
    export let arrow="";

    function animation() {
        var animation_TL = new TimelineMax();
        animation_TL.add("init");
        animation_TL.from("h3", 1, {y: "-200rem", ease: "Circ.easeOut"}, "init");
        animation_TL.to("h3", 2, {opacity: 1, ease: "Circ.easeOut"}, "init");

        animation_TL.to(".subheadline", 1, {opacity: 1, ease: "Circ.easeInOut"},"init+=1.5");
        animation_TL.to(".down-arrow", 1, {opacity: 0.5, ease: "Circ.easeInOut"},"init+=2");

        animation_TL.add("initLoop");
        animation_TL.to(arrow01, 1, {opacity: 0.8, ease: "Circ.easeInOut", repeat: -1, yoyo: true}, "initLoop");
        animation_TL.to(arrow02, 1, {opacity: 0.6, ease: "Circ.easeInOut", repeat: -1, yoyo: true}, "initLoop+=0.5");
        animation_TL.to(arrow03, 1, {opacity: 0.4, ease: "Circ.easeInOut", repeat: -1, yoyo: true}, "initLoop+=1");
    }

    onMount(() => {
        animation();
      });

</script>

<style type="text/scss">
    .header {
        pointer-events: none;
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
        padding-top: 3rem;
        line-height: 1rem;
        width: 100%;
        text-align: center; 
        position: absolute;
        z-index: 10;
        overflow: hidden; 
        h3 {
            font-weight: 200;
            letter-spacing: 0.05rem;
            color: #FFFFFF; 
            position: absolute;
            width: 100%;  
            opacity: 0;
            margin: 0 auto;
        }
        .subheadline {
            margin-top: 1.7rem;
            color: #149ED9;
            opacity: 0;
        }

        .down-arrow {
            width: 2rem;
            display: flex;
            margin: auto;
            margin-top: .5rem;
            display: block;
            opacity: 0;

			#arrow01 {
				position: relative;
			}

			#arrow02 {
				position: relative;
				top: -.7rem;
			}

			#arrow03 {
				position: relative;
				top: -1.4rem;
			}
		}
    }
</style>

<div class="header">
    <h3>{headline}</h3>
    <div id="instructions">
        <p class="subheadline">{subheadline}</p>
        <div class="down-arrow">
            <img id="arrow01" class="img arrow" src={arrow} alt="down arrow" />
            <img id="arrow02" class="img arrow" src={arrow} alt="down arrow" />
            <img id="arrow03" class="img arrow" src={arrow} alt="down arrow" />
        </div>
    </div>
</div>